import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/info.tsx
function Info({ strokeWidth = 1.5, role = "img", ...svg }) {
	return /* @__PURE__ */ jsxs("svg", {
		role,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		...svg,
		children: [
			/* @__PURE__ */ jsx("circle", {
				cx: "12",
				cy: "12",
				r: "10"
			}),
			/* @__PURE__ */ jsx("path", { d: "M12 16v-4" }),
			/* @__PURE__ */ jsx("path", { d: "M12 8h.01" })
		]
	});
}
//#endregion
export { Info };
